import { Icon } from '@spotnana/blocks/src/Icon/Icon';
import { Typography } from '@spotnana/blocks/src/Typography/Typography';
import minutesToDurationString from 'obt-common/date-utils/minutesToDurationString';
import { ILayoverInfo } from 'obt-common/types/flight';
import { Trans, useTranslation } from 'react-i18next';
import { container, swap_icon } from './styles';

interface IProps {
  layover: ILayoverInfo;
  showLeftIcon?: boolean;
}

const HiddenStops = ({ layover, showLeftIcon = true }: IProps) => {
  const { t: tt } = useTranslation('WEB');
  const { layoverDuration, layoverAirportName, layoverAirportCode } = layover;
  let layoverString = '';
  if (layoverDuration > 0) {
    layoverString = `${minutesToDurationString(layoverDuration)} `;
  }
  return (
    <div css={container}>
      {showLeftIcon && <Icon name="ArrowRevertSwap" css={swap_icon} />}
      <Trans t={tt} values={{ layoverDuration, layoverString, layoverAirportName, layoverAirportCode }}>
        <Typography variant="body2" color="secondary">
          {!!layoverString && `${layoverString} `}
          hidden stop in {'{{layoverAirportName}}'} ({'{{layoverAirportCode}}'}). De-boarding not allowed.
        </Typography>
      </Trans>
    </div>
  );
};

export { HiddenStops };
